import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Storage } from "@ionic/storage";
import { AppVersion } from "@ionic-native/app-version";
import { Platform } from "ionic-angular";
import { Device } from "@ionic-native/device";
import { AppPreferences } from "../../shared/local/app-preferences.local";
import { FcmNative } from "../../native/fcm.native";
import { PlatformServiceProvider } from "../platform/platform-service";

export interface FcmAddUserMultiAccountDto {
  registerToken: {
    company_code: any,
    employee_id: string
  },
  deleteToken: Array<{ company_code: any, employee_id: string }>
}
@Injectable()
export class FcmServiceProvider {
  goPath: string = "https://apigreatday.dataon.com/gdsignal/";
  accessToken: any;
  headerOptions: any;
  headerOptionsJson: any;
  app_key: any = 'greatday-7e013';
  device_information: any;

  constructor(public http: HttpClient,
    public storage: Storage,
    public appVersion: AppVersion,
    public platform: Platform,
    public device: Device,
    public appPreferences: AppPreferences,
    public fcmNative: FcmNative,
    public platformServiceProvider: PlatformServiceProvider
  ) {
    this.platform.ready().then(() => {
      this.setAuthorization()
      if (this.platform.is('cordova')) {
        this.device_information = 'platform:' + this.device.platform + ' ' + 'model:' + this.device.model + ' ' + 'manufacture:' + this.device.manufacturer + ' ' + 'version:' + this.device.version + ' ' + 'UUID:' + this.device.uuid;
        this.appVersion.getPackageName().then(result => {
          if (result == "com.dataon.sunfishgoqa") {
            this.app_key = 'greatday-qa-027157'
          } else {
            this.app_key = 'greatday-7e013'
          }
        })
      } else {
        this.device_information = 'browser'
        this.app_key = 'greatday-7e013'
      }
    })
  }

  setAuthorization() {
    this.storage.ready().then(async () => {
      const result = JSON.parse(await this.storage.get('SFGoAuth'));
      if (result) {
        this.accessToken = result.id;
        this.headerOptions = new HttpHeaders().set('Authorization', this.accessToken);
        this.headerOptionsJson = new HttpHeaders().set('Authorization', this.accessToken).append('Content-Type', 'application/json');
      }
    })
  }

  addUser(criteria: any) {
    criteria.app_key = this.app_key;
    criteria.device_information = this.device_information;
    return this.http.post(this.goPath + 'notifications', criteria);
  }

  async deleteUser() {
    try {
      const token = await this.appPreferences.getFcmData();
      if (token) {
        await this.http.delete(this.goPath + 'notifications?' + 'app_key=' + encodeURI(this.app_key) + '&token=' + encodeURI(token)).toPromise();
      }
    } catch (error) {
      console.log(error);
    }
  }

  async addUserMultiAccount(data: FcmAddUserMultiAccountDto) {
    const device = await this.platformServiceProvider.getPlatform();
    const body = {
      app_key: this.app_key,
      token: await this.fcmNative.getToken(),
      platform: device.Platform.toLocaleLowerCase(),
      device_information: this.device_information,
      deleteToken: data.deleteToken,
      registerToken: data.registerToken
    }

    return this.http.post(this.goPath + 'notifications/multiAccount', body).toPromise()
  }

}



// WEBPACK FOOTER //
// ./src/providers/fcm-service/fcm-service.ts